// client/src/routes/app/fiscal/declarations.$declarationId/route.tsx — the declaration branch ·
// FISC-007 (04 §7's route tree, §8.11).
//
// §7 gives SCR-FISC-003 a `route.tsx` with an `index.tsx` and a `submission.tsx` under it,
// which is the DETAIL-TABS shape of §6.5: one URL segment for the declaration, two places
// inside it. This file is the segment — it holds the two gates and nothing else, so that both
// children get them without either remembering to.
//
// The gates are `index.tsx`'s and D-1271's: `Fiscal.Read` is what the API enforces, the role
// pair is 04 §8.11's heading, which no permission can express.

import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { RequireAnyRole, RequirePermission } from '@/components/layout/route-guards';
import { fiscalVisible } from '@/config/fiscal';

export const Route = createFileRoute('/app/fiscal/declarations/$declarationId')({
  // Withdrawn from view with the fiscal module (D-2780), for the branch and both its screens;
  // see `fiscal/index.tsx`.
  beforeLoad: () => {
    if (!fiscalVisible()) throw redirect({ to: '/app/dashboard' });
  },
  component: DeclarationBranch,
});

function DeclarationBranch() {
  return (
    <RequirePermission permission="Fiscal.Read">
      <RequireAnyRole roles={['owner', 'accountant']}>
        <Outlet />
      </RequireAnyRole>
    </RequirePermission>
  );
}
